import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const trophyEmojis = ["🥇", "🥈", "🥉"];
const bgColors = [
  "bg-gradient-to-r from-yellow-200 to-yellow-50",
  "bg-gradient-to-r from-gray-200 to-gray-50",
  "bg-gradient-to-r from-orange-100 to-orange-50",
];
const textColors = ["text-yellow-700", "text-gray-600", "text-orange-600"];

const Leaderboard = ({ questId, setHoveredAnswer, setHoverPosition }) => {
  const [entries, setEntries] = React.useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchLeaderboard = async () => {
      try {
        const res = await fetch(`${BACKEND_URL}/answers/leaderboard/${questId}`);
        const data = await res.json();
        if (!res.ok) throw new Error(data.message);
        const sorted = (data.leaderboard || [])
          .filter(Boolean)
          .sort((a, b) => b.points - a.points)
          .slice(0, 3);
        setEntries(sorted);
      } catch (err) {
        console.error("❌ Leaderboard fetch failed:", err);
      }
    };

    fetchLeaderboard();
  }, [questId]);

  const handleMouseEnter = (entry, e) => {
    const rect = e.target.getBoundingClientRect();
     setHoveredAnswer(entry.answerSnippet);
     setHoverPosition({
        top: rect.top + window.scrollY,
        left: rect.left + window.scrollX,
    });
  };

  const handleMouseLeave = () => {
    setHoveredAnswer(null);
  };

  if (!entries.length) return null;

  return (
    <div className="relative w-[250px] p-3 rounded-xl shadow-xl border border-blue-200 bg-white z-10 animate-slide-up">
      <h3 className="text-sm font-bold text-blue-600 mb-1">🏆 Top Solvers</h3>
      <p className="text-[11px] text-gray-500 italic mb-2">Hover to view answers</p>
      <ul className="space-y-3">
        {entries.map((entry, i) => (
          <li
            key={entry.answerId}
            className={`flex justify-between items-center gap-2 px-2 py-1 rounded-lg ${bgColors[i]} transition-transform hover:scale-[1.02]`}
          >
            <div className="flex items-center gap-2 overflow-hidden">
              <span className={`text-lg ${textColors[i]}`}>{trophyEmojis[i]}</span>
              <button
                onClick={() => navigate(`/${entry.username}`)}
                onMouseEnter={(e) => handleMouseEnter(entry, e)}
                onMouseLeave={handleMouseLeave}
                className="text-cyan-600 font-semibold text-sm truncate hover:underline"
              >
                {entry.fullName}
              </button>
            </div>
            <span className="text-xs text-gray-500">{entry.points} pts</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Leaderboard;
